<template>
  <div class="l-content">
    <div class="l-container">
      <div class="c-container">
        <div class="c-title u-ptxl">
          <span class="u-anim-slideup">入力されたメールアドレスへ確認メールを送信しました</span>
        </div>
      </div>
    </div>

    <div class="l-container">
      <div class="c-container">
        <div class="c-body u-ptl">
          <div>
            <span>メールアドレスを認証するためのメールが送信されましたので、届いたメールを確認して認証を行い、次のステップへ進んでください。</span>
          </div>
          <div class="c-body--gray">
            <span>※メールアドレスが認証されないと次のステップに進めません。</span>
          </div>
        </div>
      </div>
    </div>

    <div class="l-container">
      <div class="c-container">
        <div class="u-ptl">
          <router-link :to="{ name : 'emailAuthorization' }">認証URLの有効期限が切れてしまった場合はこちら</router-link>
        </div>
      </div>
    </div>

    <div class="l-container">
      <div class="c-container">
        <div class="u-ptm">
          <a href="https://plus.gigbase.jp/talent/talent-help/3469/#mail" target="_blank">メールが届かない場合はこちら</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  name: "EmailAuthorizationSent",
  created() {
    this.$emit('page-navbar', false);
  },
}
</script>

<style scoped lang="scss">
span {
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.03em;
  text-align: left;
}

a {
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.03em;
  text-align: left;
  font-size: 14px;
  line-height: 14px;
}

.c-title {
  // ヘッダー分
  margin-top: 60px;

  font-size: 18px;
  line-height: 18px;
}

.c-body {
  font-size: 14px;
  line-height: 14px;

  &--gray {
    color: #A6A5A5;
  }
}
</style>
